export default {
  CAISO: {
    map: false,
    nodeKey: "Node ID",
    nodeKeyType: "text",
    nodeName: "Node ID",
    dateKey: "Interval Start Time",
    priceKey: "MW",
    nodeService: "data-services/caiso/nodes",
    realTimeService: "data-services/caiso/real-time-locational-marginal-prices",
    dayAheadService: "data-services/caiso/day-ahead-locational-marginal-prices",
  },
  CHILE: {
    map: false,
    nodeService: "data-services/chile/nodes",
    nodeKey: "Node ID",
    nodeName: "Node Name",
    dateKey: "Timestamp",
    priceKey: "LMP",
    dayAheadService: "data-services/chile/locational-marginal-prices",
  },
  EIA: {
    map: false,
    nodeKey: "Series ID",
    nodeKeyType: "text",
    nodeName: "name",
    nodeService: "data-services/eia/fuel-groups",
  },
  "EIA-SOURCES": {
    map: false,
    nodeKey: "series_id",
    nodeKeyType: "text",
    nodeName: "name",
    nodeService: "data-services/eia/sources",
  },
  ERCOT: {
    "Day-Ahead": {
      map: false,
      nodeService: "data-services/ercot/buses",
      nodeKey: "Bus Name",
      nodeName: "Bus Name",
      nodeKeyType: "text",
      dateKey: "Timestamp",
      priceKey: "LMP",
      dayAheadService: "data-services/ercot/day-ahead-locational-marginal-prices",
    },
    "Real-Time": {
      map: false,
      nodeService: "data-services/ercot/settlement-points",
      nodeKey: "Settlement Point",
      nodeName: "Settlement Point",
      nodeKeyType: "text",
      dateKey: "Timestamp",
      priceKey: "LMP",
      realTimeService: "data-services/ercot/real-time-locational-marginal-prices",
    },
  },
  ISONE: {
    map: false,
    nodeKey: "Location ID",
    nodeKeyType: "number",
    dateKey: "Local Time",
    nodeName: "Location Name",
    nodeService: "data-services/isone/nodes",
    realTimeService: "data-services/isone/five-min-locational-marginal-prices",
    dayAheadService: "data-services/isone/day-ahead-locational-marginal-prices",
    priceKey: "Locational Marginal Price ($/MWh)",
  },
  MISO: {
    map: false,
    nodeKey: "Node",
    nodeKeyType: "text",
    nodeName: "Node",
    dateKey: "Timestamp",
    priceKey: "LMP",
    nodeService: "data-services/miso/nodes",
    realTimeService: "data-services/miso/real-time-locational-marginal-prices",
    dayAheadService: "data-services/miso/real-time-locational-marginal-prices",
  },
  NYISO: {
    map: true,
    nodeService: "data-services/nyiso/nodes",
    nodeKey: "PTID",
    nodeKeyType: "number",
    nodeName: "Name",
    dateKey: "Time Stamp",
    priceKey: "LBMP ($/MWHr)",
    realTimeService: "data-services/nyiso/real-time-prices-generation",
    dayAheadService: "data-services/nyiso/day-ahead-locational-marginal-prices-generation",
  },
  PJM: {
    map: false,
    nodeKey: "Pricing Node ID",
    nodeKeyType: "number",
    nodeName: "Pricing Node Name",
    dateKey: "Datetime",
    dayAheadPriceKey: "Total LMP Day Ahead",
    realTimePriceKey: "Total LMP Real Time",
    nodeService: "data-services/pjm/nodes",
    realTimeService: "data-services/pjm/real-time-locational-marginal-prices",
    dayAheadService: "data-services/pjm/day-ahead-locational-marginal-prices",
  },
  SPP: {
    map: false,
    nodeKey: "id",
    nodeKeyType: "number",
    nodeName: "Node",
    dateKey: "Timestamp",
    priceKey: "LMP",
    nodeService: "data-services/spp/nodes",
    realTimeService: "data-services/spp/real-time-locational-marginal-prices",
    dayAheadService: "data-services/spp/day-ahead-locational-marginal-prices",
  },
};
